import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFacebookF,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"

// Styles
import * as styles from "./FooterContactCTA.module.scss"

const FooterContactCTA = props => {
  return (
    <div className={styles.FooterContactCTA}>
      {props.title && <h3>{props.title}</h3>}

      <div className={styles.socialNetworks}>
        {props.facebook && (
          <a href={props.facebook}>
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
        )}

        {props.twitter && (
          <a href={props.twitter}>
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="39" fill="none"><path fill="#fff" d="M22.625 17.038 36.467.948h-3.28l-12.02 13.97-9.6-13.97H.497l14.516 21.127L.496 38.948h3.28l12.692-14.754 10.138 14.754h11.072l-15.054-21.91Zm-4.493 5.223-1.471-2.104L4.958 3.417h5.038l9.445 13.51 1.47 2.103 12.277 17.56H28.15L18.132 22.262Z"/></svg>
          </a>
        )}

        {props.instagram && (
          <a href={props.instagram}>
            <svg width="38" height="38" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" fill="#fff"><path d="M19 3.421c5.077 0 5.678.023 7.674.112 1.856.081 2.858.393 3.526.653a5.875 5.875 0 0 1 2.182 1.418 5.843 5.843 0 0 1 1.417 2.182c.26.668.572 1.677.653 3.525.09 2.004.112 2.605.112 7.674 0 5.077-.023 5.678-.112 7.674-.081 1.856-.393 2.858-.653 3.526a5.875 5.875 0 0 1-1.417 2.182 5.843 5.843 0 0 1-2.182 1.417c-.668.26-1.678.572-3.526.654-2.004.089-2.605.11-7.674.11-5.077 0-5.678-.021-7.674-.11-1.856-.082-2.858-.394-3.526-.654a5.876 5.876 0 0 1-2.182-1.417 5.844 5.844 0 0 1-1.417-2.182c-.26-.668-.572-1.678-.653-3.526-.09-2.003-.112-2.605-.112-7.674 0-5.076.023-5.678.112-7.674.081-1.856.393-2.857.653-3.525a5.876 5.876 0 0 1 1.417-2.182A5.844 5.844 0 0 1 7.8 4.186c.668-.26 1.678-.572 3.526-.653 1.996-.09 2.597-.112 7.674-.112ZM19 0c-5.158 0-5.804.022-7.83.111-2.019.09-3.407.416-4.61.884-1.253.49-2.315 1.135-3.369 2.196C2.131 4.245 1.484 5.307.995 6.554.527 7.764.2 9.144.11 11.162.022 13.197 0 13.842 0 19c0 5.158.022 5.804.111 7.83.09 2.019.416 3.407.884 4.61.49 1.253 1.135 2.315 2.196 3.369a9.287 9.287 0 0 0 3.363 2.189c1.21.468 2.59.794 4.608.883 2.027.09 2.672.112 7.83.112 5.159 0 5.805-.023 7.83-.112 2.02-.089 3.407-.415 4.61-.883a9.288 9.288 0 0 0 3.362-2.19 9.287 9.287 0 0 0 2.19-3.361c.467-1.21.793-2.59.882-4.61.09-2.026.112-2.671.112-7.83 0-5.158-.023-5.804-.112-7.83-.089-2.018-.415-3.406-.883-4.609a8.9 8.9 0 0 0-2.174-3.377 9.287 9.287 0 0 0-3.362-2.189c-1.21-.468-2.59-.794-4.61-.883C24.804.022 24.159 0 19 0Z"/><path d="M19 9.24c-5.388 0-9.76 4.372-9.76 9.76s4.372 9.76 9.76 9.76 9.76-4.372 9.76-9.76S24.388 9.24 19 9.24Zm0 16.09a6.332 6.332 0 0 1 0-12.66 6.332 6.332 0 0 1 0 12.66ZM31.424 8.854a2.279 2.279 0 1 1-2.278-2.278 2.284 2.284 0 0 1 2.278 2.278Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h38v38H0z"/></clipPath></defs></svg>
          </a>
        )}
      </div>

      {props.link && <a href={props.link.url}>{props.buttonText}</a>}
    </div>
  )
}

export default FooterContactCTA
